<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        :message="'<b>Note:</b> When creating a note, by default, it will be visible to all team members who report directly to you. You can use the <b>Display to</b> field to send notes to an individual team member who reports to you.'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                    v-on:selectOption="selectOption($event)"
                    v-on:removeOption="removeOption($event)"
                />
                <div :class="'col-md-12'" class="p-0 formdynamic__item" v-if="form_data.date_method === 1 || form_data.date_method === 2">
                    <div class="formdynamic__item__field">
                        <label v-html="`${form_data.date_method === 1 ? 'Days' : 'Hours'}: ${form_data.date_method === 1 || form_data.date_method === 2 ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label"/>
                        <input
                            :placeholder="''"
                            :disabled="false"
                            :type="'number'" 
                            :required="form_data.date_method === 1 || form_data.date_method === 2 ? true : false"
                            v-model="form_data.numeric_time_drop"
                        />
                    </div>
                </div>

                <FormDynamic
                    :form_format="form_format_3"
                    :form_data="form_data"
                    :array_options="[]"
                    :for_update="false"
                />

                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>
import NoteFormResources from './note_form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'

export default {

    name:   'NoteFormModal',

    props: [
        "title",
        "rest_api",
        "notyf",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data: NoteFormResources.form_data,
            form_format: NoteFormResources.form_format,
            form_backup: {...NoteFormResources.form_data},
            form_format_3: NoteFormResources.form_format_3,
        }
    },

    watch: {
        'form_data.numeric_time_drop'(val)
        {
            if (val <= 0)
            {
                this.form_data.numeric_time_drop = 1
            }
            else if (val >= 100)
            {
                this.form_data.numeric_time_drop = 100
            }
        },
    },

    methods:{
        form_submit_local()
        {
            var index = this.form_data.associate_id.indexOf(0);
            if (index !== -1) 
            {
                this.form_data.associate_id.splice(index, 1);
            }
            this.form_submit()

        },
        selectOption(event)
        {
            setTimeout(() => {
                if(event === 0)
                {
                    this.form_data.associate_id = this.array_options.associate_id.map(associate => associate.id)
                }
                else
                {
                    if(this.form_data.associate_id.length === (this.array_options.associate_id.length - 1))
                    {
                        this.form_data.associate_id.push(0)
                    }

                }
                
            }, 250);
            
            
        },
        removeOption(event)
        {
            setTimeout(() => {
                if(event === 0)
                {
                    this.form_data.associate_id = []
                }
                else
                {
                    if(this.form_data.associate_id.length < this.array_options.associate_id.length)
                    {
                        var index = this.form_data.associate_id.indexOf(0);
                        if (index !== -1) 
                        {
                            this.form_data.associate_id.splice(index, 1);
                        }

                    }
                }
            }, 250);
        }

    },

    mounted(){

    }
    
}
</script>